.game {
  width: 100%;
  display: grid;
  justify-items: center;
  gap: 10px;
}

.stage {
  position: relative;
  width: 100%;
  max-width: 720px;
}

.slot {
  position: absolute;
  left: 50%;
  top: 50%;
  width: var(--w);
  margin-left: calc(var(--w) / -2);
  margin-top: calc(var(--w) * -0.872);
  transition-property: transform, opacity;
  transition-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1), ease;
}

.wiggle {
  animation: wiggle 0.5s ease-in-out;
}

@keyframes wiggle {
  30% {
    transform: translateX(calc(var(--w) * var(--sx))) rotate(calc(var(--sx) * 14deg));
  }
  70% {
    transform: translateX(calc(var(--w) * var(--sx) * -0.6));
  }
}

.hint {
  margin: 0;
  min-height: 20px;
  font-size: 13px;
  color: var(--muted);
  transition: opacity 0.3s;
}

.hidden {
  opacity: 0;
}

.result {
  display: grid;
  justify-items: center;
  gap: 8px;
  text-align: center;
  animation: rise 0.45s ease both;
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

.name {
  margin: 0;
  font-family: var(--font-display);
  font-style: italic;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.15;
  color: var(--text);
}

.keywords {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}

.keywords span {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid var(--line);
  color: var(--muted);
}

.meaning {
  margin: 0;
  max-width: 44ch;
  font-size: 14px;
  line-height: 1.5;
  color: var(--muted);
}

.again {
  margin-top: 4px;
  border: 0;
  border-radius: 999px;
  padding: 11px 22px;
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
  box-shadow:
    0 0 0 1px var(--fill-ring),
    0 8px 20px var(--fill-glow);
  font: inherit;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
}

@media (prefers-reduced-motion: reduce) {
  .slot {
    transition-duration: 0.01s !important;
  }
  .wiggle,
  .result {
    animation: none;
  }
}
